@if (demoMode()) {
  <cyc-mixing
    mode="batcher"
    plant="Plant 1"
    loadingPoint="Loading Point 1"
    registration="CC12345"
    [drumSpeed]="drumSpeed()"
    [mixingEvent]="demoData()"
    [class.fullscreen-component]="true"
    [showHeader]="true"
    [allowDebug]="true"
  ></cyc-mixing>
} @else {
  @if (missingParams().length) {
    <div class="cyc-mixing-messages">
      <h1>Missing parameters, please check the URL</h1>
      @for (param of missingParams(); track $index) {
        <div>
          <span class="text-error mr-3 self-center">&#10006;</span
          >{{ param }}</div
        >
      }
    </div>
  } @else if (errors()?.length) {
    <div class="cyc-mixing-messages">
      @for (error of errors(); track $index) {
        <div>{{ error }}</div>
      }
    </div>
  } @else {
    @if (params().plant && params().loadingPoint) {
      <cyc-mixing
        mode="batcher"
        [plant]="batchPlantName()"
        [loadingPoint]="params().loadingPoint"
        [registration]="$safeNavigationMigration(mixingData()?.registration)"
        [drumSpeed]="$safeNavigationMigration(mixingData()?.drumVectorRpm)"
        [mixingEvent]="$safeNavigationMigration(mixingData()?.mixingEvent)"
        [class.fullscreen-component]="true"
        [showHeader]="true"
        [allowDebug]="true"
      ></cyc-mixing>
    } @else {
      <div class="cyc-mixing-messages">
        <div>Loading...</div>
      </div>
    }
  }
}
